var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-primary-nav'),_c('app-toolbar'),_c('v-content',[_c('app-progress-bar'),_c('app-flash-messages'),_vm._t("default"),_c('app-footer'),_c('app-auth-dialog'),_c('pending-folder-dialog')],2),_c('app-user-nav'),_c('app-notifications',{attrs:{"group":"main","position":"top right","duration":3500,"animation":_vm.notificationAnimation}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dfa43f6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/layouts/Default.vue
// module id = null
// module chunks = 